import { MODEL_NUMBER_COLUMN_WIDTHS } from "./TableModelNumbers.constants"
import type { ColumnsType } from "antd/es/table"
import type { TModelNumberTableRow } from "types/modelNumbers.type"
import type { TModelNumberColumnKey } from "./columnWidths.helper"

/**
 * @param pixelWidths Measured pixel widths, for the virtualized table — antd ignores its
 * virtual body unless every column width is numeric. Omit for the ordinary tables, which
 * keep the percentage widths and flex with their own container.
 */
export const ModelNumbersColumns = (
	pixelWidths?: Record<TModelNumberColumnKey, number>,
): ColumnsType<TModelNumberTableRow> => {
	const widthOf = (key: TModelNumberColumnKey): string | number =>
		pixelWidths ? pixelWidths[key] : MODEL_NUMBER_COLUMN_WIDTHS[key]

	return [
		{
			title: "Model numbers",
			dataIndex: "model_number",
			key: "model_number",
			width: widthOf("modelNumber"),
			ellipsis: true,
		},
		{
			title: "WIDTH",
			dataIndex: "width",
			key: "width",
			width: widthOf("width"),
			ellipsis: true,
		},
		{
			title: "HEIGHT",
			dataIndex: "height",
			key: "height",
			width: widthOf("height"),
			ellipsis: true,
		},
		{
			title: "DEPTH",
			dataIndex: "depth",
			key: "depth",
			width: widthOf("depth"),
			ellipsis: true,
		},
		{
			title: "MIN SIZE",
			dataIndex: "min_size",
			key: "min_size",
			width: widthOf("minSize"),
			ellipsis: true,
			render: (size: string) => (size ? `${size}` : 0),
		},
		{
			title: "AVG SIZE",
			dataIndex: "avg_size",
			key: "avg_size",
			width: widthOf("avgSize"),
			ellipsis: true,
			render: (size: string) => (size ? `${size}` : 0),
		},
		{
			title: "MAX SIZE",
			dataIndex: "max_size",
			key: "max_size",
			width: widthOf("maxSize"),
			ellipsis: true,
			render: (size: string) => (size ? `${size}` : 0),
		},
	]
}
